

import Vue, {PropType} from "vue";
import {SimpleAttributeValue} from "../../../model/cart/LocalCartItem";

export default Vue.extend({
  name: "StringAttributeValue",
  props: {
    attrValue: {
      type: Object as PropType<SimpleAttributeValue>,
      default: () => ({
        value: "",
      }),
    },
  },
});
